<template>
  <div>
    <v-layout row v-if="alertMessage" mb-3>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <app-alert @dismissed="dismiss" :text="alertMessage"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm10 offset-sm1 md6 offset-md3>
        <h3 class="headline mb-3">Existing Customer Login</h3>
        <v-card light class="mb-5">
          <v-card-text>
            <!-- <v-container> -->
              <v-form 
                @submit.prevent="onSignin()"
                v-model="valid"
                ref="form"
                lazy-validation                
              >
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      v-model="email"
                      type="email"
                      :rules="[rules.required, rules.email]"
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      :rules="[rules.required]"
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>                
                <v-layout row wrap align-bottom>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn
                      @click="goBack"
                      class="ml-0"
                      outline
                      color="secondary"
                    >&laquo; Back</v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn outline primary type="submit" :loading="loading" :disabled="loading === true || valid === false" class="mr-0 mb-4">
                      Sign In                      
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center text-sm-right">
                    <router-link to="forgot-password">Forgot password?</router-link>
                  </v-flex>
                </v-layout>
              </v-form>
            <!-- </v-container> -->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <account-picker :dialogIsOpen="showAccountsPickerDialog" :accounts="accounts" @selectedAccount="setSelectedAccount" @toggleDialog="showAccountsPickerDialog = false"></account-picker>
  </div>
</template>

<script>
  import AccountPicker from './AccountPicker'
  export default {
    data () {
      return {
        valid: true,
        showAccountsPickerDialog: false,
        alertMessage: null,
        userAccount: null,
        email: '',
        password: '',
        rules: {
          required: (v) => {
            return !!v || 'Required'
          },
          email: (v) => {
            if (this.brand.rules.email) {
              return this.brand.rules.email(v)
            } else {
              return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            }
          }
        }
      }
    },
    components: {
      AccountPicker
    },
    mounted () {
      if (this.$route.query.timeout && parseInt(this.$route.query.timeout) === 1) {
        this.alertMessage = 'Your session timed out. Please login again to activate your SIM.'
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      accounts () {
        return this.$store.getters.accounts
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          // this.$router.push('/')
          this.$router.push({ name: 'verify-pin' })
        }
      },
      accounts (val) {
        if (val && val.length > 1) {
          this.showAccountsPickerDialog = true
        } else {
          this.showAccountsPickerDialog = false
        }
      },
      error (val) {
        if (!val) { return }

        var status = val.response.status
        switch (status) {
          case 403:
            this.alertMessage = 'Invalid username or password. Please try again.'
            break

          case 404:
            this.alertMessage = `No valid account found. Please <a href="${this.$router.resolve({ name: 'new-activation' }).href}">sign-up</a> to create an account.`
            break

          case 500:
            this.alertMessage = 'Oops, Something went wrong. Please try again later.'
            break
        }
      }
    },
    methods: {
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
      },
      onSignin () {
        if (this.$refs.form.validate()) {
          this.dismiss()

          this.$store.dispatch('signInUser', {
            email: this.email,
            password: this.password
          }).catch(() => {
            console.error('here we error: ', arguments)
          })
        } else {
          console.log('invalid...')
        }
      },
      setSelectedAccount (account) {
        this.$store.dispatch('setDefaultAccount', account)
      },
      dismiss () {
        this.$store.dispatch('clearError')
        this.alertMessage = null
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/user/Signin.vue